/* import __COLOCATED_TEMPLATE__ from './simple.hbs'; */
import Component from '@glimmer/component';

import { Button } from '@repo/design-system-kit';

import styles from './simple.module.css';

interface BackButtonSimpleSignature {
  // The arguments accepted by the component
  Args: {};
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class BackButtonSimpleComponent extends Component<BackButtonSimpleSignature> {
  button = Button;
  styles = styles;
}
